<section class="batch-orders-container">
  <header class="header">
    <div class="title">Print history</div>
    <div role="button" class="close-btn-container" mat-dialog-close>
      <img src="/assets/images/scan/close_icon.svg" alt="" />
    </div>
  </header>
  <mat-divider class="batch-orders-divider"></mat-divider>
  <div class="searchInput">
    <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
    <button mat-button mat-icon-button aria-label="Clear">
      <img style="margin-bottom: 4px" src="../../../../../assets/icons/search.svg" />
    </button>

    <input
      [(ngModel)]="searchInput"
      style="width: 60%; margin-right: auto; margin-bottom: 10px; border: none"
      matInput
      type="text"
      placeholder="Search"
      (keyup)="updatePrintedRows($event)" />
    @if (searchInput !== '') {
    <img
      class="clear-filter"
      style="position: absolute; padding-top: 12px; padding-left: 30px; min-width: 14px; min-height: 14px"
      src="/assets/images/fast-filters/clear_search_icon.svg"
      (click)='updatePrintedRows("")' />
    }
  </div>
  <div class="batch-orders-content" mat-dialog-content>
    <table class="table" cdk-table [dataSource]="filteredRows">
      <ng-container cdkColumnDef="BatchName">
        <th style="padding-left: 25px" cdk-header-cell *cdkHeaderCellDef>Batch name</th>
        <td style="padding-left: 25px" cdk-cell *cdkCellDef="let filteredRows">{{ filteredRows.name }}</td>
      </ng-container>

      <ng-container cdkColumnDef="PrintingTimes">
        <th cdk-header-cell *cdkHeaderCellDef>Times printed</th>
        <td cdk-cell *cdkCellDef="let filteredRows">{{ filteredRows.printCounter }}</td>
      </ng-container>

      <ng-container cdkColumnDef="LastPrintingTime">
        <th cdk-header-cell *cdkHeaderCellDef>Last printed</th>
        <td cdk-cell *cdkCellDef="let filteredRows">
          <span class="recently-printed-batch__info__printed--date">
            {{ filteredRows.lastPrint | date: "MMM dd, hh:mmaaaaa" }}m
          </span>
        </td>
      </ng-container>

      <ng-container cdkColumnDef="Actions">
        <th cdk-header-cell *cdkHeaderCellDef></th>
        <td class="actions-cell" cdk-cell *cdkCellDef="let filteredRows"></td>
      </ng-container>

      <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
      <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-divider class="batch-orders-divider-bottom"></mat-divider>
  </div>
</section>
